import axiosInstance from '../axiosInstance';

export const getProductsForReorder = async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.search) params.append('search', filters.search);
    if (filters.categoryID) params.append('categoryID', filters.categoryID);
    
    const response = await axiosInstance.get(`/brand/reorder-list?${params.toString()}`);
    return response.data;
};

export const reorderProducts = async (reorderedItems) => {
    const response = await axiosInstance.put('/brand/reorder', { reorderedItems });
    return response.data;
};

export const getCategories = async () => {
    const response = await axiosInstance.get('/categories/all-category');
    return response.data;
};
